import { getOnboardingContext, isHomeFlow } from "@helpers/localStorage"
import { useTranslation } from "react-i18next"
import { Plan } from "src/types"

interface Props {
  plan?: Plan
}

export default function PlanFooterText({ plan }: Props) {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const plansCopyKey =
    context === "cars"
      ? "pages.checkout.plansCars"
      : context === "pets"
        ? "pages.checkout.plansPets"
        : isHomeFlow()
          ? "pages.checkout.plansHome"
          : "pages.checkout.plans"

  return (
    <div className="space-y-1 text-center">
      {plan === "one-time" ? (
        <p className="text-text-secondary text-sm">
          {t(`${plansCopyKey}.oneTimeNoSubscription`)}
        </p>
      ) : (
        <p className="text-text-secondary text-sm">
          {t(`${plansCopyKey}.cancelAnytime`)}
        </p>
      )}
      <p className="text-sm font-semibold">
        {t(`${plansCopyKey}.moneyBackGuarantee`)}
      </p>
    </div>
  )
}
